import React from 'react';
import styles from './sellerpagecustomermanageblock1.module.css';
import searchIcon from './../../assets/search_icon.png'; 
import ImageWithFallback from '../ImageWithFallback';

const CustomerManagement = () => {
  const customers = [
    { name: 'Nguyễn Văn A', address: 'Tỉnh Thừa Thiên Huế, huyện Nam Đông, xã Hương Lộc', orders: '3 đơn', spend: '300 000 đ' },
    { name: 'Nguyễn Văn A', address: 'Tỉnh Thừa Thiên Huế, huyện Nam Đông, xã Hương Lộc', orders: '1 đơn', spend: '210 000 đ' },
    { name: 'Nguyễn Văn A', address: 'Tỉnh Thừa Thiên Huế, huyện Nam Đông, xã Hương Lộc', orders: '2 đơn', spend: '180 000 đ' }
  ];

  return (
    <div className={styles.customerManagement}>
      <div className={styles.header}>
        <h2>Quản lý khách hàng</h2>
      </div>
      <div className={styles.headerActions}>
        <span>Số lượng: 123 người</span>
        <button className={styles.filterBtn}>Thêm bộ lọc</button>
      </div>
      <div className={styles.searchBar}>
        <div className={styles.searchInputContainer}>
          <input type="text" placeholder="Tìm khách hàng" className={styles.searchInput} />
          <button className={styles.searchButton}>
            <ImageWithFallback loading="lazy" src={searchIcon} alt="Search" />
          </button>
        </div>
        <select className={styles.sortDropdown}>
          <option value="default">Mặc định</option>
        </select>
      </div>
      <table className={styles.customerTable}>
        <thead>
          <tr className={styles.titleRow}>
            <th className={styles.title}>Tên khách hàng</th>
            <th className={styles.title}>Địa chỉ</th>
            <th className={styles.title}>Số đơn hàng</th>
            <th className={styles.title}>Số tiền chi tiêu</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((customer, index) => (
            <tr key={index}>
              <td>{customer.name}</td>
              <td>{customer.address}</td>
              <td>{customer.orders}</td>
              <td>{customer.spend}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className={styles.pagination}>
        <span>Rows per page:</span>
        <select>
          <option value="10">10</option>
        </select>
        <span>1-2 of 2</span>
        <button>&lt;</button>
        <button>&gt;</button>
      </div>
    </div>
  );
};

export default CustomerManagement;
